import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from "firebase/auth";
import Icon from '@mdi/react';
import { mdiCheck } from "@mdi/js";
import { useState } from 'react';
import { auth } from '../utils/firebase';
import FailureModal from "./FailureModal";
import { toggleModal } from "../utils/uiUtils";

function ChangePassword() {
    const [isNewPasswordValid, setIsNewPasswordValid] = useState(false);
    const [isConfirmMatched, setIsConfirmMatched] = useState(false);

    const checkPasswordReqs = (newPassword) => {
        setIsNewPasswordValid(newPassword.length >= 8 &&
            /[A-Z]/.test(newPassword) &&
            /[a-z]/.test(newPassword) &&
            /[!@#$%^&*(),.?":{}|<>]/.test(newPassword));
    }

    const checkConfirmPassword = (confirmPassword) => {
        var newPassword = document.getElementById("newPassword").value;
        setIsConfirmMatched(newPassword.length >= 8 && newPassword === confirmPassword);
    }

    function validatePasswordForm() {
        document.getElementById("newPasswordError").classList.add("is-hidden");
        document.getElementById("currentPasswordEmpty").classList.add("is-hidden");
        var currentPassword = document.getElementById("currentPassword").value;

        currentPassword = currentPassword.trim();
        if (!currentPassword) {
            document.getElementById("currentPasswordEmpty").classList.remove("is-hidden");
            return false;
        }

        if (!isNewPasswordValid || !isConfirmMatched) {
            document.getElementById("newPasswordError").classList.remove("is-hidden");
            return false;
        }

        return true;
    }

    const changePassword = async () => {
        if (!validatePasswordForm()) {
            return;
        }

        var user = auth.currentUser;
        var currentPassword = document.getElementById("currentPassword").value;
        var newPassword = document.getElementById("newPassword").value;
        const credential = EmailAuthProvider.credential(user.email, currentPassword);

        try {
            await reauthenticateWithCredential(user, credential);
            await updatePassword(user, newPassword);
            document.getElementById("currentPassword").value = "";
            document.getElementById("newPassword").value = "";
            document.getElementById("confirmPassword").value = "";

            toggleModal("modal-success");
        } catch (error) {
            toggleModal("modal-error");
        }
    }

    return (
        <div className="container indent-from-top ml-2 mr-2">
            <div className="mt-5">
                <header className="has-text-centered mb-4">
                    <p className="subtitle has-text-weight-semibold">Change Password</p>
                </header>
            </div>

            <div className="content">
                Password requirements:
                <ul>
                    <li>Minimum length 8</li>
                    <li>1 upper and 1 lower case letter</li>
                    <li>1 number</li>
                    <li>1 special character</li>
                </ul>
            </div>

            <div className="field">
                <label className="label">Current Password</label>
                <div className="control has-icons-right">
                    <input className="input" type="password" placeholder="Current password" id="currentPassword" />
                </div>
            </div>

            <div className="field">
                <label className="label">New Password</label>
                <div className="control has-icons-right">
                    <input className="input" type="password" placeholder="New  password" id="newPassword" onChange={(event) => { checkPasswordReqs(event.currentTarget.value); }} />
                    <span className={"icon is-small is-right " + (isNewPasswordValid ? "" : "is-hidden")} style={{ color: "green" }}>
                        <Icon path={mdiCheck} />
                    </span>
                </div>
            </div>

            <div className="field">
                <label className="label">Confirm New Password</label>
                <div className="control has-icons-right">
                    <input className="input" type="password" placeholder="Confirm password" id="confirmPassword" onChange={(event) => { checkConfirmPassword(event.currentTarget.value); }} />
                    <span className={"icon is-small is-right " + (isConfirmMatched ? "" : "is-hidden")} style={{ color: "green" }}>
                        <Icon path={mdiCheck} />
                    </span>
                </div>
            </div>
            <div className="notification is-warning is-light is-hidden has-text-7" id="currentPasswordEmpty">
                You must enter your current password.
            </div>
            <div className="notification is-warning is-light is-hidden has-text-7" id="newPasswordError">
                Check your new password meets requirements, and that your confirmed password matches.
            </div>

            <div className="field is-grouped">
                <div className="control">
                    <button className="button is-primary" onClick={changePassword}>Submit</button>
                </div>
                <div className="control">
                    <button className="button is-primary is-light" onClick={() => { window.history.back() }}>Cancel</button>
                </div>
            </div>

            <FailureModal message="Error changing password. Make sure your old password is correct and try again" />

            <div id="modal-success" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Password Changed!</p>
                        <button className="delete" aria-label="close" onClick={() => { document.getElementById('modal-error').classList.remove('is-active') }}></button>
                    </header>
                    <section className="modal-card-body">
                        Your password has been succesfully changed. 
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button" aria-label="close" onClick={() => { window.history.back() }}>Close</button>
                    </footer>
                </div>
            </div>
        </div>

    )
}

export default ChangePassword;